<template>
    <div class="approvalset" v-if="permisShow('审批设置查看')">
        <!--审批配置-->
        <div class="approvalset-set">
            <div class="approvalset-set-item">
                <div class="approvalset-set-item-title">
                    <div>房源-审批配置</div>
                    <el-button @click="updateApproval" v-points v-if="permisShow('审批设置编辑')">保存</el-button>
                </div>
                <div class="approvalset-set-item-content">
                    <div class="approvalset-set-item-content-item">
                        <div>
                            <div class="label"></div>
                            <div class="checkname">录入房源是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherHouse" placeholder="请选择" @change="open1">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" >
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <div class="label"></div>
                            <div class="checkname">录入钥匙是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherKey" placeholder="请选择" @change="open2">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="approvalset-set-item-content-item">
                        <div>
                            <div class="label"></div>
                            <div class="checkname">录入实勘是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherExploration" placeholder="请选择" @change="open3">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <div class="label"></div>
                            <div class="checkname">录入房源带看是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherHouseLook" placeholder="请选择" @change="open4">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="approvalset-set-item-content-item">
                        <div>
                            <div class="label"></div>
                            <div class="checkname">变更房源属性是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherHouseUpdate" placeholder="请选择" @change="open5">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <div style="color: #FF8000;margin-left: 30px;">（当选择“是”时，以下属性至少必须选择一项）</div>
                        </div>
                    </div>
                    <div class="approvalset-set-item-content-item">
                        <el-checkbox-group v-model="websiteCompany.houseUpdateOption" :disabled="!websiteCompany.whetherHouseUpdate">
                            <el-checkbox v-for="(item,index) in checkNames" :label="item.value" :key="index">{{item.valueDesc}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <div class="approvalset-set-item">
                <div class="approvalset-set-item-title">
                    <div>客源-审批配置</div>
                </div>
                <div class="approvalset-set-item-content">
                    <div class="approvalset-set-item-content-item">
                        <div>
                            <div class="label"></div>
                            <div class="checkname">录入客源是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherCustomer" placeholder="请选择" @change="open6">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="approvalset-set-item">
                <div class="approvalset-set-item-title">
                    <div>黑名单-审批配置</div>
                </div>
                <div class="approvalset-set-item-content">
                    <div class="approvalset-set-item-content-item">
                        <div>
                            <div class="label"></div>
                            <div class="checkname">录入黑名单是否需要审批</div>
                            <el-select v-model="websiteCompany.whetherBlack" placeholder="请选择" @change="open7">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--审批流配置-->
        <div class="approvalset-set1">
            <div class="approvalset-set-item-title">
                <div>审批流配置</div>
                <el-button v-if="permisShow('审批流配置')" @click="toSet">新增审批流</el-button>
            </div>
            <div class="table">
                <div class="search">
                    <div class="search-item">
                        <div class="search-label">审批流名称</div>
                        <div class="search-item-name">
                            <el-input clearable v-model="setSearch.checkName" placeholder="请输入" @input="getSet"></el-input>
                        </div>

                    </div>
                    <div class="search-item">
                        <div class="search-label">类型</div>
                        <el-select clearable v-model="setSearch.checkType" placeholder="请选择" @change="getSet">
                            <el-option
                                    v-for="item in checkType"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="space">
                    <span class="statusColor" v-if="stateBtn">禁用后，对应的功能不再走审批流，视为直接通过</span>
                </div>
                <el-table border style="width: 100%" :header-cell-style="setHeaderStyle" :data="setList">
                    <el-table-column prop="name" label="审批流名称" width="180"></el-table-column>
                    <el-table-column prop="type" label="类型" width="180"></el-table-column>
                    <el-table-column prop="remarks" label="备注" width="180"></el-table-column>
                    <el-table-column prop="status" width="180">
                        <template slot="header" slot-scope="scope">
                            <div style="display:flex;align-items:center;justify-content:center;">
                                <span>是否启用</span>
                                <i class="iconfont icon-tixing" style="color:#ff8000;font-size:20px;" @mouseenter="stateBtn=true" @mouseleave="stateBtn=false"></i>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            <el-switch style="display: block" :disabled="!permisShow('审批流配置')" active-color="#5e75e6" inactive-color="#e6e6e6" active-value="YES" inactive-value="NO" v-model="scope.row.whetherOpen" @change="switchSetChange(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column prop="checkEmployeeIds" label="审批人"></el-table-column>
                    <el-table-column prop="address" label="操作" width="180" v-if="permisShow('审批流配置')">
                        <template slot-scope="scope" >
                            <span style="cursor: pointer;color: #5E75E6;padding-right: 6px;" @click="editSet(scope.row)">编辑</span>
                            <span style="cursor: pointer;color: #FF0000" @click="deleteSet(scope.row)" v-if="scope.row.whetherDelete==true">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

    </div>
</template>

<script>
    import {querySet,updateSet} from "@/api/checkingIn";
    import {queryCheckType,queryWebsiteCompany,updateApproval,queryWhetherOpen} from'@/api/approveManage'
    export default {
        name: "approvalSet",
        data(){
            let permisList = JSON.parse(sessionStorage.getItem("permisList"));
            return {
                permisList,
                setList: [], //审批设置列表
                setSearch:{
                    checkName:'',
                    checkType:'',
                },//审批列表查询
                checkType:[],//审批类型
                stateBtn:false,//是否启用
                options: [{value: false, label: '否'}, {value: true, label: '是'}],
                websiteCompany:{houseUpdateOption:[]},//审批配置数据
                checkNames:[
                    {
                        value:'owner_name',
                        valueDesc:'业主姓名'
                    },{
                        value:'owner_phone',
                        valueDesc:'业主电话'
                    },{
                        value:'partner_name',
                        valueDesc:'共有人姓名'
                    },{
                        value:'partner_phone',
                        valueDesc:'共有人电话'
                    },{
                        value:'price',
                        valueDesc:'总价/租金'
                    },{
                        value:'status',
                        valueDesc:'状态'
                    },
                ],
                whetherOpen:{},//是否开启审批流
                whetherKey:'',
                whetherExploration:'',
                whetherHouselook:'',
                whetherCustomer:'',
                whetherHouseupdate:'',
                whetherHouse:'',
                whetherBlack:'',
            }
        },
        watch: {
            // setList() {
            //     this.getQueryCheck(); //查询审批流
            // }
        },
        methods:{
            permisShow(data) {
                // 权限配置
                let result = this.permisList.indexOf(data);
                if (result >= 0) {
                    return true;
                } else {
                    return false;
                }
            },
            //表单头部颜色
            setHeaderStyle() {
                return "background-color: #F2F4FF";
            },
            //查询审批配置
            queryWebsiteCompany(){
                this.$post(queryWebsiteCompany).then(res=>{
                    this.websiteCompany = res.data
                })
            },
            //查询审批流是否开启
            queryWhetherOpen(){
               this.$post(queryWhetherOpen).then(res=>{
                   this.whetherOpen = res.data;
                   this.whetherOpen.map((item,index)=>{
                       if (item.type==='whether_key'){
                            this.whetherKey = item.whetherOpen;
                       }else  if (item.type==='whether_exploration'){
                           this.whetherExploration = item.whetherOpen;
                       }else  if (item.type==='whether_house_look'){
                           this.whetherHouselook = item.whetherOpen;
                       }else  if (item.type==='whether_customer'){
                           this.whetherCustomer = item.whetherOpen;
                       }else  if (item.type==='whether_house_update'){
                           this.whetherHouseupdate = item.whetherOpen;
                       }else  if (item.type==='whether_house'){
                           this.whetherHouse = item.whetherOpen;
                       }else  if (item.type==='whether_black'){
                           this.whetherBlack = item.whetherOpen;
                       }
                   });
               });
            },
            //保存审批设置
            updateApproval(){
                if (this.websiteCompany.whetherHouseUpdate==true){
                    if (this.websiteCompany.houseUpdateOption.length===0){
                        this.$message.error('请至少选择一个变更房源属性');
                        return;
                    }
                }
                let params = Object.assign({},this.websiteCompany);
                this.$post(updateApproval,params).then(res=>{
                    if (res.success) {
                        this.$message.success(res.msg);
                        this.queryWebsiteCompany();
                    }else {
                        this.$message.error(res.msg);
                    }

                })
            },
            open1(val) {
                if (this.whetherHouse=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherHouse = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }


            },
            open2(val) {
                if (this.whetherKey=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherKey = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }


            },
            open3(val) {
                if (this.whetherExploration=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherExploration = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }


            },
            open4(val) {
                if (this.whetherHouselook=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherHouseLook = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }


            },
            open5(val) {
                if (this.whetherHouseupdate=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherHouseUpdate = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }else {
                    if (val === false){
                        this.websiteCompany.houseUpdateOption=[];
                    }
                }


            },
            open6(val) {
                if (this.whetherCustomer=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherCustomer = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }


            },
            open7(val) {
                if (this.whetherBlack=='NO') {
                    if (val===true) {
                        this.websiteCompany.whetherBlack = false;
                        this.$confirm('对应的审批流尚未开启，请先开启再来修改配置', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            center: true
                        }).then(() => {
                        }).catch(() => {
                        });
                    }
                }


            },
            //查询审批类型
            queryCheckType(){
              this.$post(queryCheckType).then(res=>{
                  this.checkType=res.data;
              })
            },
            //查询审批设置
            getSet() {
                let params = Object.assign({},this.setSearch);
                this.$post(querySet,params).then(res => {
                    if (res.success) {
                        this.setList = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });
            },
            //考勤审批设置是否启用
            switchSetChange(val) {
                let params = {
                    whetherOpen: val.whetherOpen,
                    id: val.id
                };
                this.$post(updateSet, params).then(res => {
                    if (res.success) {
                        this.$message({
                            type: "success",
                            message: res.msg
                        });
                        this.getSet();
                        this.queryWhetherOpen();
                    }
                });
            },
            //新增审批流
            toSet(){
                sessionStorage.removeItem("setId");
                this.$router.push("/checkingSet");
            },
            //编辑审批设置
            editSet(val) {
                sessionStorage.setItem("setId", val.id);
                this.$router.push("/checkingSet");
            },
            //删除审批设置
            deleteSet(val) {
                this.$confirm("删除后将不可恢复，请谨慎操作！", "确定要删除吗？", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    center: true,
                    distinguishCancelAndClose: true
                }).then(() => {
                    let params = {
                        whetherOpen: "DELETE",
                        id: val.id
                    };
                    this.$post(updateSet, params).then(res => {
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: res.msg
                            });
                            this.getSet();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                    });
                });
            },
        },
        mounted() {
            this.queryWebsiteCompany();
            this.queryWhetherOpen();
            this.getSet();
            this.queryCheckType();
        }
    }
</script>
<style lang="less">
    .approvalset{
        .el-switch.is-checked .el-switch__core:after{
            background: #ffffff;
        }
        .approvalset-set-item-content-item{
            .el-input {
                width: 98px;
                height: 30px;
                margin-left: 90px;
                .el-input__inner{
                    width: 98px;
                    height: 30px;
                }
            }
        }
        .search-item{
            .el-input {
                width: 148px;
                height: 30px;
                margin-left: 8px;
                .el-input__inner{
                    width: 148px;
                    height: 30px;
                }
            }
        }
        .search-item-name{
            .el-input {
                width: 148px;
                .el-input__inner{
                    width: 148px;
                }
            }
        }

    }
</style>
<style scoped lang="less">
.approvalset{
    margin: 10px 0 10px 14px;
    /*padding-bottom: 20px;*/
    .approvalset-set-item-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 64px;
        /*line-height: 64px;*/
        border-bottom: 1px solid #DCDFE6;
        >div{
            color: #333333;
            font-size: 16px;
            font-weight: bold;
        }
        .el-button{
            height: 36px;
            padding:0 25px;
            background: #5E75E6;
            color: #ffffff;
            margin-right: 26px;
            font-size: 14px;
        }

    }
    &-set{
        &-item{
            background: #ffffff;
            margin-bottom: 8px;
            padding-left: 27px;
            padding-bottom: 20px;
            font-size: 14px;
            color: #333333;
            &-content{
                &-item{
                    width: 1000px;
                    display: flex;
                    justify-content: space-between;
                    padding: 20px 0 0 0;
                    >div{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        .label{
                            width: 6px;
                            height: 6px;
                            background: #FF8000;
                            border-radius: 50%;
                            margin-right: 8px;
                        }
                        .checkname{
                            width: 195px;
                            text-align: left;
                        }
                    }
                    .el-checkbox-group{
                        margin:  0;
                        .el-checkbox{
                            color: #333333!important;
                        }

                    }
                }
            }
        }
    }
    &-set1{
        background: #ffffff;
        padding-left: 27px;
        .search{
            color: #333333;
            display: flex;
            justify-content: flex-start;
            .search-item{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 50px;
                padding-top: 10px;
                font-size: 14px;
            }

        }
        .table{
            margin-top: 10px;
            padding-bottom: 50px;
            .space {
                height: 20px;
                line-height: 20px;
                /*width: 100%;*/
                margin-left: 660px;
                .statusColor {
                    color: #ff8000;
                    font-size: 14px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>